import { render, staticRenderFns } from "./alert-confirm-modal.vue?vue&type=template&id=4da606aa&scoped=true"
import script from "./alert-confirm-modal.vue?vue&type=script&lang=ts"
export * from "./alert-confirm-modal.vue?vue&type=script&lang=ts"
import style0 from "./alert-confirm-modal.vue?vue&type=style&index=0&id=4da606aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da606aa",
  null
  
)

export default component.exports